module.exports = __webpack_public_path__ + "assets/img/feature-visual-3.bbcd37a9.png";